import api from "./axios";
import type { Term } from "../types";

interface CreateTermData {
  name: string;
  year: number;
  startDate?: string | null;
  endDate?: string | null;
}

export const termsApi = {
  list: async (params?: { year?: number }): Promise<Term[]> => {
    const res = await api.get<Term[]>("/terms", { params });
    return res.data;
  },

  create: async (data: CreateTermData): Promise<Term> => {
    const res = await api.post<Term>("/terms", data);
    return res.data;
  },

  update: async (id: number, data: Partial<CreateTermData>): Promise<Term> => {
    const res = await api.put<Term>(`/terms/${id}`, data);
    return res.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/terms/${id}`);
  },
};
